import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import className from 'classnames';
import {
  Accordion,
  Icon,
  IconButton,
  Label,
  Tooltip,
} from '@folio/stripes-components';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './styles.css';
import SectionFields from '../SectionFields';

function SectionAccordion({
  fields,
  snapshot,
  draggableProvided,
  fieldName,
  fieldIndex,
  onSectionEdit,
  paneId,
}) {
  const usePortal = snapshot.isDragging;
  const intl = useIntl();

  const renderAccordionHeader = (index) => {
    const sectionValue = fields.value[index];
    return (
      <>
        <IconButton
          icon="edit"
          onClick={() => onSectionEdit(sectionValue)}
          onMouseDown={(e) => e.preventDefault()}
        />
        <IconButton
          icon="trash"
          onClick={() => fields.remove(index)}
          onMouseDown={(e) => e.preventDefault()}
        />
        <div className={styles.dragBtn} {...draggableProvided.dragHandleProps}>
          <Tooltip
            id="fields-builder-change-section-order-tooltip"
            text={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templateFields.builder.dragSection.tooltip.msg"
                defaultMessage="Change section order"
              />
            }
          >
            {({ ref, ariaIds }) => (
              <Icon icon="drag-drop" aria-labelledby={ariaIds.text} ref={ref} />
            )}
          </Tooltip>
        </div>
      </>
    );
  };

  const SectionElement = (
    <div
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      className={className(styles.SectionAccordionWrapper, {
        [`${styles['SectionAccordionWrapper--dragging']}`]: snapshot.isDragging,
      })}
      role="button"
    >
      <Accordion
        key={`${fieldName}-template-field}`}
        id={`${fieldName}-template-field-${fieldIndex}`}
        label={
          <Label fullWidth>
            <h2>
              {
                fields?.value[fieldIndex]?.sectionLabel?.find(
                  (locale) => locale.locale === intl.locale,
                )?.value
              }
            </h2>
          </Label>
        }
        displayWhenOpen={renderAccordionHeader(fieldIndex)}
        displayWhenClosed={renderAccordionHeader(fieldIndex)}
      >
        <div style={{ padding: '30px' }}>
          <FieldArray
            id={`template-${paneId}-fields-builder`}
            name={`${fieldName}.sectionFields`}
            component={SectionFields}
          />
        </div>
      </Accordion>
    </div>
  );

  if (!usePortal) {
    return SectionElement;
  }

  const container = document.getElementById('ModuleContainer');
  return ReactDOM.createPortal(SectionElement, container);
}

SectionAccordion.propTypes = {
  fields: PropTypes.object,
  fieldName: PropTypes.string,
  fieldIndex: PropTypes.number,
  snapshot: PropTypes.object,
  draggableProvided: PropTypes.object,
  renderAccordionHeader: PropTypes.func,
  onSectionEdit: PropTypes.func,
  paneId: PropTypes.string,
};

export default SectionAccordion;
